module.exports = __webpack_public_path__ + "media/icons/check-7333616c.png";